import React from 'react';
import { ultimateImages, mataMalihaIntro } from '../../data/ultimateData';

const UltimateAbout = () => {
 const scrollToForm = () => {
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 // Define powers data for display
 const powersData = [
 { icon: '🔱', title: 'सिर्फ नाम से सब पता', desc: 'पीड़ित का नाम बताइए, माता सब बता देंगी' },
 { icon: '', title: 'शहर/गाँव का नाम', desc: 'आपके घर का पता तुरंत बता देंगी' },
 { icon: '', title: 'समस्या देने वाला कौन', desc: 'किसकी वजह से दुख है, नाम बताएंगी' },
 { icon: '✦', title: 'समस्या का मूल कारण', desc: 'जड़ से पता करके उपाय बताएंगी' },
 ];

 return (
 <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="about-section" id="about-section" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, #101014 50%, #0B0B0E 100%)' }}>
 
 {/* Background Effects - Purple Theme */}
 <div className="absolute inset-0">
 <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#0B0B0E] rounded-full blur-3xl" />
 <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-[#0B0B0E] rounded-full blur-3xl" />
 </div>
 
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">

 {/* Section Header */}
 <div className="text-center mb-12">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 परिचय
 </span>
 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 माता मलीहा की दिव्य शक्ति
 </span>
 </h2>
 <p className="text-[#D8D2C6] text-lg max-w-2xl mx-auto">
 एकमात्र तांत्रिक जो <span className="text-[#F3EDE2] font-bold">सिर्फ आपका नाम सुनकर</span> सब कुछ बता देती हैं
 </p>
 </div>

 {/* Main Content */}
 <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
 
 {/* Image - full bleed, merged into background */}
 <div className="relative w-screen lg:w-[480px] -mx-4 sm:-mx-6 lg:mx-0 flex-shrink-0 -mb-16 lg:mb-0">
 <img
 src={ultimateImages.mataHeroGhat}
 alt="श्मशान साधना में लीन माता मलिहा"
 className="w-full h-auto"
 style={{ maskImage: 'radial-gradient(ellipse 90% 92% at 50% 42%, #000 42%, transparent 99%)', WebkitMaskImage: 'radial-gradient(ellipse 90% 92% at 50% 42%, #000 42%, transparent 99%)', mixBlendMode: 'lighten' }}
 loading="lazy"
 />
 </div>

 {/* Content */}
 <div className="flex-1 text-center lg:text-left">
 <h3 className="text-2xl sm:text-3xl font-bold text-[#D8D2C6] mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 {mataMalihaIntro.title}
 </h3>
 
 <p className="text-[#D8D2C6] text-lg leading-relaxed mb-6">
 {mataMalihaIntro.subtitle}
 </p>

 {/* Highlights - Purple & Gold */}
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
 <div className="flex items-center gap-3 p-4 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/40 border border-[#d4a84b]/40 hover:border-[#d4a84b]/80 transition-all">
 <span className="text-2xl">❖</span>
 <span className="text-[#F3EDE2] font-bold">25+ वर्षों का अनुभव</span>
 </div>
 <div className="flex items-center gap-3 p-4 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/40 border border-[#7a2929]/40 hover:border-[#7a2929]/60 transition-all">
 <span className="text-2xl">ॐ</span>
 <span className="text-[#7a2929] font-bold">अघोर विद्या में सिद्ध</span>
 </div>
 <div className="flex items-center gap-3 p-4 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/40 border border-[#d4a84b]/40 hover:border-[#d4a84b]/80 transition-all">
 <span className="text-2xl">✦</span>
 <span className="text-[#F3EDE2] font-bold">50,000+ समस्याओं का समाधान</span>
 </div>
 <div className="flex items-center gap-3 p-4 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/40 border border-green-500/40 hover:border-green-400/60 transition-all">
 <span className="text-2xl"></span>
 <span className="text-[#F3EDE2] font-bold">क्षमतानुसार दक्षिणा</span>
 </div>
 </div>

 {/* CTA - Gold */}
 <button
 onClick={scrollToForm}
 className="px-8 py-4 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] hover:from-[#f5d77e] hover:to-[#f5d77e] text-black text-lg font-black rounded-full shadow-xl shadow-amber-500/30 transition-all transform hover:scale-105"
 style={{ fontFamily: "'Rozha One', serif" }}
 >
 माता जी से जांच करवाएं - क्षमतानुसार
 </button>
 </div>
 </div>

 {/* Powers Section */}
 <div className="mt-16">
 <h3 className="text-2xl sm:text-3xl font-bold text-center mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 सिर्फ आपका नाम बताइए
 </span>
 </h3>
 <p className="text-center text-[#D8D2C6] mb-8 max-w-2xl mx-auto">
 माता मलिहा <span className="text-[#F3EDE2] font-bold">तुरंत</span> बता देंगी ये सब:
 </p>
 
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
 {powersData.map((power, i) => (
 <div key={i} className="text-center p-6 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/40 border border-[#d4a84b]/60 hover:border-[#d4a84b]/40 transition-all">
 <div className="text-4xl mb-3">{power.icon}</div>
 <h4 className="text-lg font-bold text-[#F3EDE2] mb-2">{power.title}</h4>
 <p className="text-[#D8D2C6]/80 text-sm">{power.desc}</p>
 </div>
 ))}
 </div>
 
 {/* Trust Builder */}
 <div className="mt-10 text-center">
 <div className="inline-block p-6 rounded-2xl bg-gradient-to-br from-[#d4a84b]/10 to-[#d4a84b]/10 border border-[#d4a84b]/30">
 <p className="text-xl text-[#D8D2C6] font-bold mb-2" style={{ fontFamily: "'Rozha One', serif" }}>
 विश्वास नहीं? एक बार अर्जी लगाकर देखें!
 </p>
 <p className="text-[#F3EDE2] text-lg">
 जांच दक्षिणा <span className="font-bold">क्षमतानुसार</span>
 </p>
 </div>
 {/* Aghori Disclaimer */}
 <div className="mt-6 p-4 rounded-xl bg-[#17171C] border border-[#5c1a1a] max-w-2xl mx-auto">
 <p className="text-[#F3EDE2] font-bold text-sm">
 ❖ <span className="text-[#F3EDE2]">अघोर विधि</span> से कार्य होता है। पूरी श्रद्धा और विश्वास हो तभी यहां आएं।
 </p>
 <p className="text-[#F3EDE2] font-bold text-sm mt-1">
 छल-कपट, दुर्भाव से ना आएं - अच्छे मन से आएं ताकि कार्य सफल हो।
 </p>
 </div>
 </div>
 </div>
 </div>
 </section>
 );
};

export default UltimateAbout;
